import {
    GET_AUDIT_TRAILS_FOR_PO_AND_USER, INSERT_AUDIT_TRAIL, GET_AUDIT_TRAIL_BY_PO_AND_LINE_ITEM_ID,
} from '../type'

const initialState = {
    auditPouser: [],
    insertaudit: [],
    getaudit: [],
    loading: true,
}

export default function auditTrailReducer(state = initialState, action) {
    switch (action.type) {

        case GET_AUDIT_TRAILS_FOR_PO_AND_USER:
            return {
                ...state,
                auditPouser: action.payload,
                loading: false

            }
        case INSERT_AUDIT_TRAIL:
            return {
                ...state,
                insertaudit: action.payload,
                loading: false

            }
        case GET_AUDIT_TRAIL_BY_PO_AND_LINE_ITEM_ID:
            return {
                ...state,
                getaudit: action.payload,
                loading: false

            }
        default: return state
    }

}